import { writable } from "svelte/store";
export const mouseState = writable({ leftPressed: false, wasLeftPressed: false, rightPressed: false, wasRightPressed: false, middlePressed: false, wasMiddlePressed: false, mousePos: { x: 0, y: 0 }, lastMousePos: { x: 0, y: 0 } });
